import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProductsConfigService } from '@approot/services';
import { sleep } from '@approot/utilities';

@Component({
  selector: 'app-provider-multi-hedge',
  templateUrl: './provider-multi-hedge.component.html',
  styleUrls: ['./provider-multi-hedge.component.scss']
})
export class ProviderMultiHedgeComponent implements OnInit {
  @Input() public hedgeMode = '';
  @Input() public form: FormGroup;
  @Input() public volBased = false;
  @Input() public isCustomHedge = false;
  @Input() public cross: string;
  @Input({ required: true }) public showExpiryDate: boolean;
  @Output() public fieldBlur = new EventEmitter();
  public inputsColors: Record<string, string> = {
    settlementDate: '#acbac3'
  };
  public isElementFocused = false;
  public isSpot = false;
  private readonly productsConfigService = inject(ProductsConfigService);
  private readonly elementRef = inject(ElementRef);

  public ngOnInit(): void {
    this.isSpot =
      this.hedgeMode === 'DeltaSpot' || this.hedgeMode === 'Custom Spot';
  }

  public changeInText(field: string, value: any): void {
    this.inputsColors[field] = value ? 'var(--near-turquoise)' : undefined;
    if (!value) {
      this.form.get(field).markAsPristine();
    }
  }

  public onElemFocus(): void {
    this.isElementFocused = true;
  }

  public onElemBlur(field: string): void {
    this.isElementFocused = false;
    this.formatValue(field);
    setTimeout(_ => {
      if (!this.isElementFocused) {
        this.fieldBlur.emit();
      }
    }, 0);
  }

  public formatValue(field: string): void {
    if (field === 'strike') {
      const ctrl = this.form.get(field);
      const val = this.productsConfigService.crossDecimalFormatter(
        ctrl.value,
        this.cross
      );
      ctrl.setValue(val);
    }
  }

  public async settlementDateCalendarChange() {
    await sleep(100);
    const dateElem = this.elementRef.nativeElement.querySelector(
      '.settlement-date input'
    );
    dateElem.blur();
  }
}
